export default class Team {

  constructor(team = {}) {
    this.id = team.id || null
    this.name = team.name || ''
    this.members = team.members || []
    this.apps = team.apps || []
  }

  static mutations() {
    return {
      setTeam: (state, team) => state.team = new Team(team),
      clearTeam: (state) => state.team = new Team(),
      updateName: (state, payload) => state.team.name = payload,
      updateMemberPermissions: (state, payload) => {
        let index = state.team.members.indexOf(payload.member)
        let member = state.team.members[index]
        member.permissions = payload.values
        state.team.members.splice(index, 1, member)
      },
      removeMember: (state, payload) => {
        let index = state.team.members.indexOf(payload)
        state.team.members.splice(index, 1)
      }
    }
  }
}
